import React, {useState} from "react";
import {
    Box,
    Typography,
    Grid,
    Paper,
    Container,
    useTheme,
    useMediaQuery,
    Divider,
} from "@mui/material";
import KazakhstanMap from "../Map";
import { kazakhstanRegions } from "../../../model/regions";

const keyIndicators = [
    {
        title: "14,5 трлн тг",
        subtitle: "Объем продукции отрасли",
    },
    {
        title: "16 млн т",
        subtitle: "Производство руды",
    },
    {
        title: "10,7 млн т",
        subtitle: "Производство очищенного металла",
    },
    {
        title: "$6,3 млрд",
        subtitle: "Объем экспорта в 2023 году (снижение на 2%)",
    },
];

const regionDetails = [
    {
        region: "Акмолинская область",
        items: [
            "Более 16 % к ВВП производит ГМК",
            "Входит в топ-5 регионов по объему производства",
        ],
    },
];

const investmentPoints = [
    "Меры по поддержанию геологоразведки",
    "Контракты по капиталовложениям с господдержкой в 2023 году привели к финансированию 5 проектов",
    "Финансирование сопутствующих услуг и цифровизации",
];

const MiningIndustryPage: React.FC = () => {

    const [selectedRegion, setSelectedRegion] = useState<string | null>(null);
    const [hoveredRegion, setHoveredRegion] = useState<string | null>(null);


    const handleRegionClick = (region: any) => {
        setSelectedRegion(region.name);
        console.log('Выбран регион:', region);
    };

    const handleRegionHover = (region: any) => {
        setHoveredRegion(region ? region.name : null);
    };
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            {/* Заголовок */}
            <Typography variant="h4" fontWeight={700} gutterBottom>
                Горно-металлургический комплекс РК
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Горно-металлургический сектор экономики, который предоставляет минеральные ресурсы для производства и экспорта
            </Typography>

            {/* Ключевые показатели */}
            <Paper elevation={3} sx={{ p: 3, mb: 5 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Ключевые показатели (на 2024 год)
                </Typography>
                <Grid container spacing={2}>
                    {keyIndicators.map((item, idx) => (
                        <Grid item xs={12} sm={6} md={3} key={idx}>
                            <Typography variant="h5" fontWeight={700}>
                                {item.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {item.subtitle}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </Paper>

            {/* Карта (заглушка) и региональная информация */}
            <Paper elevation={3} sx={{ p: 3, mb: 5 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Региональные особенности
                </Typography>

                <Box
                    sx={{
                        width: "100%",
                        backgroundColor: "#e8f5e9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 3,
                        color: "#2e7d32",
                        fontWeight: 500,
                    }}
                >
                    <KazakhstanMap
                        regions={kazakhstanRegions}
                        onRegionClick={handleRegionClick}
                        onRegionHover={handleRegionHover}
                        defaultFill="#5764f7"
                        hoverFill="#4254f5"
                        activeFill="#3244d0"
                    />
                </Box>

                {regionDetails.map((region, idx) => (
                    <Box key={idx} sx={{ mb: 2 }}>
                        <Typography variant="subtitle1" fontWeight={600}>
                            {region.region}
                        </Typography>
                        <ul>
                            {region.items.map((point, i) => (
                                <li key={i}>
                                    <Typography variant="body2">{point}</Typography>
                                </li>
                            ))}
                        </ul>
                    </Box>
                ))}
            </Paper>

            {/* Возможности для капиталовложений */}
            <Paper elevation={3} sx={{ p: 3 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Возможности для капиталовложений
                </Typography>
                <ul>
                    {investmentPoints.map((point, idx) => (
                        <li key={idx}>
                            <Typography variant="body2">{point}</Typography>
                        </li>
                    ))}
                </ul>
            </Paper>
        </Container>
    );
};

export default MiningIndustryPage;